<template>
    <div class="ls-tos__wrapper">
        <!-- ***** IMPORTANT ****** -->
        <!-- ANY UPDATES TO THE TOS MUST BE REFLECTED IN WWW.HOMEGNOME.COM AS WELL -->
        <!-- ***** IMPORTANT ****** -->
        <p data-font-size="0">
            Last Updated February 2025
            <br /><br />
            PLEASE READ THESE TERMS OF USE (“AGREEMENT” OR “TERMS OF USE”) CAREFULLY BEFORE USING
            THE WEBSITE, MOBILE APPLICATIONS, AND SERVICES OFFERED BY HOME GNOME. AND ITS
            SUBSIDIARIES (COLLECTIVELY, “COMPANY”). THIS AGREEMENT SETS FORTH THE LEGALLY BINDING
            TERMS AND CONDITIONS FOR YOUR USE OF THE WEBSITE AT https://homegnome.com, MOBILE
            APPLICATIONS, AND SERVICES PROVIDED BY COMPANY (COLLECTIVELY, THE “SERVICES”).
            <br /><br />
            Whether you are a visitor, home services professional, or a home services recipient
            (visitor, home services provider, and home services recipient, collectively, “users” or
            “you”), by using the Services in any manner, including but not limited to visiting or
            browsing the Services, you agree to be bound by this Agreement, including those
            additional terms and conditions and policies referenced herein and/or available by
            hyperlink. This Agreement applies to all users of the Services. If you are a home
            services professional, you will be required to agree to supplementary terms governing
            your use of the Company platform and provision of home services. These additional terms
            can be found at
            <a href="https://homegnome.com/eula" target="_blank" rel="noopener noreferrer">
                https://homegnome.com/eula </a
            >. <br /><br />
            If you have any questions, please refer to the help section of the Services or contact
            us at <a href="mailto:hello@homegnome.com">hello@homegnome.com</a>.
        </p>
        <h3>1. Company is a Platform</h3>
        <p data-font-size="0">
            Company acts as a platform to allow home services professionals who comply with
            Company’s policies to connect with other users who may desire home services. Company is
            not directly involved in any transactions between users. As a result, Company has no
            control over the quality of the home services provided by the home services providers or
            the truth or accuracy of the information provided by users, or the ability of home
            services professionals to complete home services in a timely manner, if at all.
            <br /><br />
            Company cannot guarantee the true identity, age, and nationality of an user. Company
            encourages users to communicate directly through the tools available on the Services.
            You may also wish to consider independent user verification or using a third-party
            service that provides additional user verification. Although service professionals are
            contractually obligated to carry adequate insurance to perform the Services, Company
            cannot guarantee this so you may wish to verify with each service professional you
            engage.
            <br /><br />
            You agree that Company is a platform and as such is not responsible or liable for any
            home services or other content posted by you, other users, or third parties on the
            Services. Your use of the Services is at your own risk.
        </p>

        <h3>2. Membership Eligibility</h3>
        <p data-font-size="0">
            Services are available only to, and may only be used by, individuals who are 18 years
            and older who can form legally binding contracts under applicable law. You represent and
            warrant that you are at least 18 years old and that all registration information you
            submit is accurate and truthful. Company may, in its sole discretion, refuse to offer
            access to or use of the Services to any person or entity and change its eligibility
            criteria at any time. This provision is void where prohibited by law and the right to
            access the Services is revoked in those jurisdictions. Individuals under the age of 18
            must at all times use the Services only in conjunction with and under the supervision of
            a parent or legal guardian who is at least 18 years of age. In all cases, the adult is
            the user and is responsible for any and all activities.
            <br /><br />
            You agree to comply with all local laws regarding online conduct and acceptable content.
            In addition, you must abide by Company’s policies as stated in the Agreement and the
            Company’s Privacy Policy, as well as all other operating rules, policies and procedures
            that may be published from time to time on the Services by Company, each of which is
            incorporated herein by reference and each of which may be updated by Company from time
            to time without notice to you.
            <br /><br />
            In addition, some services offered by Company may be subject to additional terms and
            conditions issued by Company or a third party; your use of those services is subject to
            the additional terms and conditions, which are incorporated into this Agreement by this
            reference.
            <br /><br />
            In addition, some services offered by Company may be subject to additional terms and
            conditions issued by Company or a third party; your use of those services is subject to
            the additional terms and conditions, which are incorporated into this Agreement by this
            reference.
            <br /><br />
            Keep your password secure. You are fully responsible for all activity, liability and
            damage resulting from your failure to keep your password confidential. You agree to
            immediately notify Company of any unauthorized use of your password or any breach of
            security. You also agree that Company cannot and will not be liable for any loss or
            damage arising from your failure to keep your password secure. You agree not to provide
            your username and password information in combination to any other party other than
            Company without Company’s express written permission.
            <br /><br />
            You must keep your account information up-to-date and accurate at all times, including a
            valid email address. Services are not available to temporarily or permanently banned
            users. Company reserves the right, in Company’s sole discretion, to cancel unconfirmed
            or inactive accounts. Company reserves the right to refuse service to anyone, for any
            reason, at any time.
        </p>

        <h3>3. Prohibited, Questionable and Infringing Activities</h3>
        <p class="ls-margin--bottom-none" data-font-size="0">
            You are solely responsible for your conduct and activities on and regarding to the
            Services and any and all information that you submit, post, upload, and display on the
            Services.
            <br /><br />
            Your use of Company will not:
        </p>
        <ul class="ls-margin--top-none" data-font-size="0">
            <li>be false, inaccurate or misleading;</li>
            <li>
                infringe upon any third-party’s intellectual property rights or rights of publicity
                or privacy;
            </li>
            <li>
                violate this Agreement, any website policy or community guidelines, or any
                applicable law, statute, ordinance or regulation;
            </li>
            <li>
                be defamatory, libelous, unlawfully threatening, unlawfully harassing, impersonate
                or intimidate any person (including Company staff or other users), or falsely state
                or otherwise misrepresent your affiliation with any person, through for example, the
                use of similar email address, nicknames, or creation of false account(s) or any
                other method or device;
            </li>
            <li>take any action that may undermine online reviews or feedback;</li>
            <li>be obscene or contain child pornography; and</li>
            <li>
                contain or transmit any code of a destructive nature that may damage, detrimentally
                interfere with, surreptitiously intercept or expropriate any system, data or
                personal information.
            </li>
        </ul>

        <h3>4. License Grant &amp; Restrictions</h3>
        <p data-font-size="0">
            The Company hereby grants you a non-exclusive, non-transferable, right to use the
            Services, solely for your own personal, non-commercial purposes, subject to the terms
            and conditions of this Agreement. All rights not expressly granted to you are reserved
            by the Company and its licensors. You will not (i) license, sublicense, sell, resell,
            transfer, assign, distribute or otherwise commercially exploit or make available to any
            third party the Services in any way; (ii) modify or make derivative works based upon the
            Services; (iii) create Internet "links" to the Services; (iv) reverse engineer the
            Services; (v) access the Services in order to (a) build a competitive product or
            service, (b) build a product using similar ideas, features, functions or graphics of the
            Services, or (c) copy any ideas, features, functions or graphics of the Services, or
            (vi) launch an automated program or script, including, but not limited to, web spiders,
            web crawlers, web robots, web ants, web indexers, bots, viruses or worms, or any program
            which may make multiple server requests per second, or unduly burdens or hinders the
            operation or performance of the Services.
        </p>

        <h3>5. Payment Terms</h3>
        <p data-font-size="0">
            Any fees which the Company may charge you for the Services are due immediately upon
            completion of your home services and are non-refundable. regardless of any a
            contemporaneous or subsequent termination or cancellation of your account whether by you
            or by Company, any disruption to our Services, whether planned, accidental, intentional
            or caused by any other reason whatsoever. The fees due shall be the prevailing pricing
            at the time of service. If you do not cancel or reschedule a service date already
            scheduled at least 48 hours prior to such date, you will be charged the full amount for
            the canceled or rescheduled service.
            <br /><br />
            Please note the pricing information published on the website may not reflect the
            prevailing pricing. The Company, at its sole discretion, make promotional offers with
            different features and different rates to any of our customers. These promotional
            offers, unless made to you, will have no bearing whatsoever on your offer or contract.
            The Company may change the fees for our Services as we deem necessary for our business.
            We encourage you to check back at our website periodically if you are interested about
            how we charge for the Services.
        </p>

        <h3>6. Intellectual Property Ownership</h3>
        <p data-font-size="0">
            The Company alone (and its licensors, where applicable) will own all right, title and
            interest, including all related intellectual property rights, in and to the Services.
            This Agreement is not a sale and does not convey to you any rights of ownership in or
            related to the Services, or any intellectual property rights owned by the Company. The
            Company name, the Company logo, and the product names associated with the Services are
            trademarks of the Company or third parties, and no right or license is granted to use
            them.
        </p>

        <h3>7. Personal Information</h3>
        <p data-font-size="0">
            As part of using the Services, you may obtain personal information, including email
            addresses, from other users. Without obtaining prior permission from the user, this
            personal information will only be used for Services-related communications. Company has
            not granted you a license to use the information for unsolicited commercial messages or
            unauthorized transactions. Without limiting the foregoing, without express consent from
            the user, you are not licensed to add any Company user to your email or physical mail
            list. For more information, see Company’s Privacy Policy.
            <br /><br />
            By using the Services, you agree to be contacted by the Company for any and all purposes
            arising out of or relating to this Agreement and the Services hereunder, at any
            telephone number, or physical or electronic address you provide or at which you may be
            reached. You agree that the Company may contact you in any way, including informational
            text (SMS) messages calls using prerecorded messages or artificial voice, and calls and
            messages delivered using auto telephone dialing system or an automatic texting system.
            You consent to receive SMS messages (including text messages), calls and messages
            (including prerecorded and artificial voice and autodialed) from the Company at the
            specific number(s) You have provided to the Company, or numbers the Company can
            reasonably associate with your account (through skip trace, caller ID capture or other
            means), with information or questions about this Agreement and the Services. You
            certify, warrant and represent that the telephone numbers that You have provided to the
            Company are your contact numbers. You represent that You are permitted to receive calls
            at each of the telephone numbers You have provided to the Company. You agree to promptly
            alert the Company whenever you stop using a particular telephone number. Your
            acknowledge that Your cellular or mobile telephone provider may charge you according to
            the type of plan you carry.
        </p>

        <h3>8. Mobile Message Service</h3>
        <p data-font-size="0">
            The HomeGnome mobile message service (the "Mobile Service") offered through the Company
            is provided by third-party Braze. Your use of the Mobile Service constitutes your
            agreement to these terms and conditions (“Mobile Terms”). We may modify or cancel the
            Service or any of its features without notice. To the extent permitted by applicable
            law, we may also modify these Mobile Terms at any time and your continued use of the
            Mobile Service following the effective date of any such changes shall constitute your
            acceptance of such changes. These Mobile Terms may also be revised by changes to the
            Braze platform.
            <br /><br />
            By consenting to the Mobile Service, you agree to receive recurring SMS/text messages
            from and on behalf of the Company through your wireless provider to the mobile number
            you provided. If your mobile number is registered on any state or federal Do Not Call
            list, but you then opt-in to our Service, then you are agreeing to receive text messages
            and supersede your prior decision to be placed on the Do Not Call list. Text messages
            may be sent using an automatic telephone dialing system or other technology.
            Service-related messages may include updates, alerts, and information (e.g., order
            updates, account alerts, etc.). Promotional messages may include promotions, specials,
            and other marketing offers (e.g., cart reminders). You understand that you do not have
            to sign up for this program in order to make any purchases, and your consent is not a
            condition of any purchase with the Company. Your participation in this program is
            completely voluntary.
            <br /><br />
            We do not charge for the Mobile Service, but you are responsible for all charges and
            fees associated with text messaging imposed by your wireless provider. Message frequency
            varies. Message and data rates may apply. Check your mobile plan and contact your
            wireless provider for details. You are solely responsible for all charges related to
            SMS/text messages, including charges from your wireless provider.
            <br /><br />
            You may opt-out of the Mobile Service at any time by replying the single keyword command
            STOP to any text message you receive from us. You'll receive a one-time opt-out
            confirmation text message. No further messages will be sent to your mobile device,
            unless initiated by you.
            <br /><br />
            If you have subscribed to other HomeGnome mobile message programs and wish to cancel,
            except where applicable law requires otherwise, you will need to opt out separately from
            those programs by following the instructions provided in their respective mobile terms.
            <br /><br />
            For Mobile Service support or assistance, reply HELP to any text message you receive
            from us or contact us through email at
            <a href="mailto:support@homegnome.com"> support@homegnome.com</a>. <br /><br />
            We may change any short code or telephone number we use to operate the Service at any
            time and will notify you of these changes. You acknowledge that any messages, including
            any STOP or HELP requests, you send to a short code or telephone number we have changed
            may not be received and we will not be responsible for honoring requests made in such
            messages.
            <br /><br />
            The wireless carriers supported by the Mobile Service are not liable for delayed or
            undelivered messages. You agree to provide us with a valid mobile number. If you get a
            new mobile number, you will need to sign up for the program with your new number. To the
            extent permitted by applicable law, you agree that we will not be liable for failed,
            delayed, or misdirected delivery of any information sent through the Mobile Service, any
            errors in such information, and/or any action you may or may not take in reliance on the
            information or Service.
        </p>

        <h3>9. Feedback</h3>
        <p data-font-size="0">
            Company considers any unsolicited suggestions, ideas, proposals or other material
            submitted to it by users via the Services (“Feedback”) to be non-confidential and
            non-proprietary, and Company will not be liable for the disclosure or use of any
            Feedback. If, at Company’s request, any user sends Feedback to improve the Services,
            Company will also consider that Feedback to be non-confidential and non-proprietary and
            Company will not be liable for use or disclosure of the Feedback. Any communication by
            you to Company is subject to this Agreement. You hereby grant and agree to grant
            Company, under all of your rights in the Feedback, a worldwide, non-exclusive,
            perpetual, irrevocable, royalty-free, fully-paid, sublicensable and transferable right
            and license to incorporate, use, publish and exploit Feedback for any purpose,
            commercial or otherwise, without compensation or accounting to you and without further
            recourse by you.
        </p>

        <h3>10. Information Control</h3>
        <p data-font-size="0">
            Company does not control the information provided by users. You may find some
            information provided by users to be offensive, harmful, inaccurate, or deceptive. There
            are also risks of dealing with underage persons or people acting under false pretense.
            Additionally, there may also be risks dealing with foreign nationals. By using the
            Services, you agree to accept these risks and that Company (and Company’s officers,
            directors, agents, subsidiaries, joint ventures and employees) is not responsible for
            any and all acts or omissions of users of the Services.
            <br /><br />
            Company is not responsible for the availability of outside websites or resources linked
            to or referenced on the Services. Company does not endorse and is not responsible or
            liable for any content, advertising, products, or other materials on or available from
            these websites or resources. You agree that Company will not be responsible or liable,
            directly or indirectly, for any damage or loss caused or alleged to be caused by or in
            connection with the use of or reliance on any content, goods or services available on or
            through any other websites or resources.p>
        </p>

        <h3>11. Access and Interference</h3>
        <p class="ls-margin--bottom-none" data-font-size="0">
            Company may contain robot exclusion headers which contain internal rules for software
            usage. Much of the information on Company is updated on a real-time basis and is
            proprietary or is licensed to Company by users or third-parties. You agree that you will
            not use any robot, spider, scraper or other automated means to access the Services for
            any purpose whatsoever, except to the extent expressly permitted in writing by Company.
            Additionally, you agree that you will not:
        </p>
        <ul class="ls-margin--top-none" data-font-size="0">
            <li>
                take any action that imposes, or may impose, in Company’s sole discretion, an
                unreasonable or disproportionately large load on Company’s infrastructure;
            </li>
            <li>
                copy, reproduce, modify, create derivative works from, distribute or publicly
                display any user information (except your own);
            </li>
            <li>
                interfere or attempt to interfere with the proper working of the Services or any
                activities conducted on the Services; or
            </li>
            <li>
                bypass Company’s robot exclusion headers or other measures Company may use to
                prevent or restrict access to the Services.
            </li>
        </ul>

        <h3>12. Breach</h3>
        <p data-font-size="0">
            Without limiting any other remedies, Company may, without notice, remove any user
            posting, warn Company’s community of a user’s actions, issue a warning to a user,
            temporarily suspend or terminate a user’s account, prohibit access to the Services, and
            take technical and legal steps to keep a user from accessing or using the Services and
            refuse to provide the Services to a user if Company (1) suspects a user has breached
            this Agreement or the Privacy Policy, (2) is unable to verify or authenticate any of
            your personal information, or (3) reasonably believes that a user’s actions may cause
            legal liability or financial loss to users or to Company.
        </p>

        <h3>13. Privacy</h3>
        <p data-font-size="0">
            Except as provided in the Privacy Policy, Company will not sell or disclose your
            personal information to third parties without your express consent. Company stores and
            processes information on servers hosted by Amazon Web Services that are protected by
            physical as well as technological security.
        </p>

        <h3>14. No Warranty</h3>
        <p data-font-size="0">
            COMPANY, COMPANY’S SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES, AND COMPANY’S SUPPLIERS
            PROVIDE COMPANY’S THE SERVICES “AS IS,” “AS AVAILABLE,” AND WITHOUT ANY WARRANTY OR
            CONDITION, EXPRESS, IMPLIED OR STATUTORY. COMPANY, COMPANY’S SUBSIDIARIES, OFFICERS,
            DIRECTORS, EMPLOYEES AND COMPANY’S SUPPLIERS SPECIFICALLY DISCLAIM ANY IMPLIED
            WARRANTIES OF TITLE, MERCHANTABILITY, PERFORMANCE, FITNESS FOR A PARTICULAR PURPOSE AND
            NON-INFRINGEMENT. IN ADDITION, NO ADVICE OR INFORMATION (ORAL OR WRITTEN) OBTAINED BY
            YOU FROM COMPANY WILL CREATE ANY WARRANTY. SOME STATES DO NOT ALLOW THE DISCLAIMER OF
            IMPLIED WARRANTIES, SO THE FOREGOING DISCLAIMER MAY NOT APPLY TO YOU. THIS WARRANTY
            GIVES YOU SPECIFIC LEGAL RIGHTS AND YOU MAY ALSO HAVE OTHER LEGAL RIGHTS THAT VARY FROM
            STATE TO STATE.
        </p>

        <h3>15. Limitation of Liability</h3>
        <p data-font-size="0">
            IN NO EVENT WILL COMPANY, OR COMPANY’S SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES OR
            COMPANY’S SUPPLIERS BE LIABLE FOR ANY DAMAGES WHATSOEVER, WHETHER DIRECT, INDIRECT,
            GENERAL, SPECIAL, COMPENSATORY, CONSEQUENTIAL, OR INCIDENTAL, ARISING OUT OF OR RELATING
            TO THE CONDUCT OF YOU OR ANYONE ELSE IN CONNECTION WITH THE USE OF THE SERVICES, OR THIS
            AGREEMENT, INCLUDING WITHOUT LIMITATION, LOST PROFITS, BODILY INJURY, EMOTIONAL
            DISTRESS, OR ANY SPECIAL, INCIDENTAL OR CONSEQUENTIAL DAMAGES.
            <br /><br />
            COMPANY’S LIABILITY, AND THE LIABILITY OF COMPANY’S SUBSIDIARIES, OFFICERS, DIRECTORS,
            EMPLOYEES, AND SUPPLIERS, TO YOU OR ANY THIRD PARTIES IN ANY CIRCUMSTANCE IS LIMITED TO
            THE GREATER OF (A) THE AMOUNT OF FEES YOU PAY TO COMPANY IN THE 12 MONTHS PRIOR TO THE
            ACTION GIVING RISE TO LIABILITY, AND (B) $100. SOME STATES DO NOT ALLOW THE EXCLUSION OR
            LIMITATION OF INCIDENTAL OR CONSEQUENTIAL DAMAGES, SO THE ABOVE LIMITATION OR EXCLUSION
            MAY NOT APPLY TO YOU.
        </p>

        <h3>16. Indemnity</h3>
        <p data-font-size="0">
            You agree to indemnify and hold Company and Company’s parent, subsidiaries, affiliates,
            officers, directors, agents, and employees, harmless from any claim or demand, including
            attorneys’ fees, made by any third party due to or arising out of your breach of this
            Agreement or your violation of any law or the rights of a third party.
        </p>

        <h3>17. No Guarantee</h3>
        <p data-font-size="0">
            Company does not guarantee continuous, uninterrupted access to the Services, and
            operation of the Services may be interfered with by numerous factors outside Company’s
            control.
        </p>

        <h3>18. Dispute Resolution and Release</h3>
        <p data-font-size="0">
            Company is not responsible for your interactions with other users, including without
            limitation, any dispute arising from any damage caused to a service Recipient or their
            property by a service Professional. Any dispute between you and another user must be
            resolved between yourselves. Company reserves the right, but have no obligation, to
            monitor disputes between users.

            <br /><br />
            For any dispute between you and the Company:
            <br /><br />
            You agree that any dispute, claim or controversy arising out of or relating to this
            Agreement or the breach, termination, enforcement, interpretation or validity thereof or
            the use of the Services (collectively, “Disputes”) will be settled by binding
            arbitration between you and the Company, except that each party retains the right to
            bring an individual action in small claims court and the right to seek injunctive or
            other equitable relief in a court of competent jurisdiction to prevent the actual or
            threatened infringement or misappropriation of a party’s intellectual property rights.
            You acknowledge and agree that you and the Company are each waiving the right to a trial
            by jury or to participate as a plaintiff or class in any purported class action or
            representative proceeding. Further, unless both you and the Company otherwise agree in
            writing, the arbitrator may not consolidate more than one person’s claims, and may not
            otherwise preside over any form of any class or representative proceeding. If this
            specific paragraph is held unenforceable, then the entirety of this “Dispute Resolution”
            section will be deemed void. Except as provided in the preceding sentence, this “Dispute
            Resolution” section will survive any termination of this Agreement.
            <br /><br />
            The arbitration will be administered by the American Arbitration Association (“AAA”) in
            accordance with the Commercial Arbitration Rules and the Supplementary Procedures for
            Consumer Related Disputes (the “AAA Rules”) then in effect, except as modified by this
            “Dispute Resolution” section. The Federal Arbitration Act will govern the interpretation
            and enforcement of this Section.
            <br /><br />
            A party who desires to initiate arbitration must provide the other party with a written
            Demand for Arbitration as specified in the AAA Rules. The arbitrator will be either a
            retired judge or an attorney licensed to practice law in the state of Texas and will be
            selected by the parties from the AAA’s roster of consumer dispute arbitrators. If the
            parties are unable to agree upon an arbitrator within seven days of delivery of the
            Demand for Arbitration, then the AAA will appoint the arbitrator in accordance with the
            AAA Rules.
            <br /><br />
            Unless you and the Company otherwise agree, the arbitration will be conducted in the
            county where you reside. If your claim does not exceed $10,000, then the arbitration
            will be conducted solely on the basis of documents you and the Company submit to the
            arbitrator, unless you request a hearing or the arbitrator determines that a hearing is
            necessary. If your claim exceeds $10,000, your right to a hearing will be determined by
            the AAA Rules. Subject to the AAA Rules, the arbitrator will have the discretion to
            direct a reasonable exchange of information by the parties, consistent with the
            expedited nature of the arbitration.
            <br /><br />
            The arbitrator will render an award within the time frame specified in the AAA Rules.
            The arbitrator’s decision will include the essential findings and conclusions upon which
            the arbitrator based the award. Judgment on the arbitration award may be entered in any
            court having jurisdiction thereof. The arbitrator’s award damages must be consistent
            with the terms of the “Limitation of Liability” section below as to the types and the
            amounts of damages for which a party may be held liable. The arbitrator may award
            declaratory or injunctive relief only in favor of the claimant and only to the extent
            necessary to provide relief warranted by the claimant’s individual claim.
            <br /><br />
            Your responsibility to pay any AAA filing, administrative and arbitrator fees will be
            solely as set forth in the AAA Rules.
            <br /><br />
            Notwithstanding the provisions of the modification-related provisions above, if the
            Company changes this “Dispute Resolution” section after the date you first accepted this
            Agreement (or accepted any subsequent changes to this Agreement), you may reject these
            changes by providing us written notice of your rejection by mail or hand delivery to:
            Home Gnome, 814 San Jacinto Blvd Suite 202 Austin, TX 78701, or by email from the email
            address associated with your Account to:
            <a href="mailto:hello@homegnome.com"> hello@homegnome.com</a> within 30 days of the date
            the change became effective, as indicated in the “Last update” date above. In order to
            be effective, the notice must include your full name and clearly indicate your intent to
            reject changes to this “Dispute Resolution” section. By rejecting changes, you are
            agreeing that you will arbitrate any Dispute between you and the Company in accordance
            with the provisions of this “Dispute Resolution” section as of the date you first
            accepted this Agreement (or accepted any subsequent changes to this Agreement).You
            release Company (and Company’s officers, directors, agents, subsidiaries, joint ventures
            and employees) from any and all claims, demands and damages (actual and consequential)
            of every kind and nature, known and unknown, suspected and unsuspected, disclosed and
            undisclosed, arising out of or in any way connected with disputes with one or more
            users, or an outside party.
        </p>

        <h3>19. Miscellaneous</h3>
        <p data-font-size="0">
            If any provision of this Agreement is held unenforceable, then the provision will be
            modified to reflect the parties’ intention. All remaining provisions of this Agreement
            will remain in full force and effect. You and Company are independent contractors, and
            no agency, partnership, joint venture, employee-employer or franchiser-franchisee
            relationship is intended or created by this Agreement. Company reserves the right to
            modify or terminate the Services for any reason, without notice, at any time. This
            Agreement will be governed by and construed in accordance with the laws of the State of
            Texas, including its conflicts of law rules. You agree that any dispute arising from or
            relating to the subject matter of this Agreement will be governed by the exclusive
            jurisdiction and venue of the state and Federal courts of Travis County, Texas. Unless
            otherwise specified herein, all notices will be in writing and will be deemed to have
            been duly given when received, if personally delivered or sent by certified or
            registered mail, return receipt requested; when receipt is electronically confirmed, if
            transmitted by facsimile or e-mail; or the day after it is sent, if sent for next day
            delivery by recognized overnight delivery service. Electronic notices should be sent to
            <a href="mailto:hello@homegnome.com"> hello@homegnome.com</a>. All provisions of this
            Agreement which by their nature should survive termination will survive termination,
            including, without limitation, ownership provisions, warranty disclaimers, indemnity and
            limitations of liability. <br /><br />
            Company reserves the right to alter this Agreement and any other policies at any time,
            so please review the policies frequently. If Company makes a material change Company
            will notify you here, by email, by means of a notice on our home page, or other places
            Company deems appropriate. What constitutes a “material change” will be determined at
            Company’s sole discretion, in good faith, and using common sense and reasonable
            judgment.
        </p>
    </div>
</template>
<script>
export default {
    name: 'HgTosText',
};
</script>
<style lang="scss" scoped>
h3 {
    margin-top: rem(0);
}
</style>
